<script>

import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import 'vue3-lottie/dist/style.css'
import exportFromJSON from "export-from-json"
import {helpers, required} from "@vuelidate/validators";
import moment from "moment/moment";
import useVuelidate from "@vuelidate/core";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Cotações",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  setup() {
    return { v$: useVuelidate() };
  },
  components: { Layout, PageHeader, Loader,   },
  data() {
    return {

      title: 'Cotações',
      items: [
        {
          text: 'Comercial',
          href: '/',
        },
        {
          text: 'Cotações',
          active: true,
        },
      ],
      errosValid: null,
      loadingList: true,
      loadingGraph: true,
      cotafrtsTable: null,
      pesqTextFilter: '',
      statusFilter: 'T',



    }
  },

  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      status: {
        required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
    }
  },

  methods: {


    exportExcel(){
      console.log('exportExcel')
      const data = this.cotafrtsTable
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/cotafrts`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)


        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`);
        }else{
          this.cotafrtsTable = res.data[0]
          this.title = `(${this.cotafrtsTable.length}) Cotações`
          this.loadingList = false
          this.loadingGraph = false
        }
      })
    },

    deletouReg(dataID){
      console.log('deletouReg_pai dataid:')
      console.log(dataID)

      this.loadingList = true
      api.delete(`${getBaseUrl()}api/cotafrt`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },


    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'AB':
          result = 'Aberto'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CO':
          result = 'Concluída'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.$router.push(`/cotafrt/editar/${dataID}`)
    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.deletouReg(dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      console.log(this.regSelecionado)
      this.submitted = true

      if (this.regSelecionado.nopalini && this.regSelecionado.nopalfim) {
        console.log('formSubmit_validado')
        this.showModal = false
        // this.alterouReg(this.regSelecionado)

        // console.log(regSelecionado)
        this.loadingList = true

        this.errosValid = []
        api.post(`${getBaseUrl()}api/cotarfrt`, {
          cotarfrtData: this.regSelecionado
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.produtoData = res.data[0]
          // this.loadingList = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.atualizaDataList()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingList = false
        })



      }
    },


    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },



  mounted() {
    console.log('mounted cotarFrt-list_0')
    this.atualizaDataList()
  },
}
</script>

<template>

  <Layout>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-3">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                      <option value="SE">Sem Endereço</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-5">
                <div class="text-sm-end">

                  <router-link :to="`/cotafrt/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Nova Cotação
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <div class="table-responsive mb-0">
              <table class="table align-middle table-nowrap" v-if="cotafrtsTable">
                <thead class="table-light">
                <tr>

                  <th class="align-middle">ID</th>
                  <th class="align-middle">Origem</th>
                  <th class="align-middle">Destino</th>
                  <th class="align-middle">Data</th>
                  <th class="align-middle">Status</th>
                  <th class="align-middle">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in cotafrtsTable" :key="data.id">
                  <td>
                    <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">{{
                        data.id
                      }}</a>
                  </td>
                  <td>{{ data.cepori }} </td>
                  <td>{{ data.cepdest }} </td>

                  <td>{{ formatDateTime(data.created_at) }} </td>


<!--              <span class="badge badge-pill badge-soft-success font-size-11 badge-soft-success">-->
<!--                Ativo-->
<!--              </span>-->

                    <td>
                      <span
                          class="badge badge-pill badge-soft-success font-size-11"
                          :class="data.status === 'CO' ? 'badge-soft-success' :
                                  data.status === 'AB' ? 'badge-soft-warning' :
                                  data.status === 'EL' ? 'badge-soft-info' : 'badge-soft-danger'">
                        {{ nomeStatus(data.status)  }}
                      </span>
                    </td>



                  <td>
                    <div class="button-items">

                      <b-button variant="outline-success" @click="editar(data.id)">
                        <i class="mdi mdi-pencil d-block font-size-16"></i>
                      </b-button>

                      <b-button variant="outline-danger" @click="deletar(data.id)">
                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                      </b-button>
                    </div>
                  </td>

                </tr>
                </tbody>
              </table>


            </div>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>

              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>



    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


  </Layout>
</template>
